import { Inject } from '@odinjs/odin';

import { HPMSOnClickTermUse } from '@philips-emr/hpms-components';
import { FetchAPI, FieldAPI, FormAPI, PanelAPI, TextAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnBeforeFetch, OnBeforeSubmit, OnCancel, OnChange, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent, FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { Validator } from '@philips-emr/tws-core/lib/services/model-service';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { ChamadoNovoAliases as Aliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { Routes } from '../../definitions/routes';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

import { Call } from './chamados-controller';

interface CallType {
  dsCallType: string,
  nrSequenceCallType: number,
  required: string,
  nrSeqResponsabilityTerm: number
}

@Controller({ fragment: FragmentNames.CHAMADO_NOVO })
class ChamadoNovoController extends BaseController {

  @Inject(Aliases.FORM_NEW_CALL)
  private formNewCall: FormAPI;
  @Inject(Aliases.FIELD_REQUIRED_ATTACHMENT)
  private fieldRequiredAttachment: FieldAPI;
  @Inject(Aliases.FETCH_GUIDANCE)
  private fetchGuidance: FetchAPI;
  @Inject(Aliases.TEXT_GUIDANCE)
  private textGuidance: TextAPI;
  @Inject(Aliases.FIELD_RESPONSABILITY_TERM)
  private fieldResponsabilityTerm: FieldAPI;
  @Inject(Aliases.PANEL_RESPONSABILITY_TERM)
  private panelResponsabilityTerm: PanelAPI;

  @OnMount(Aliases.PANEL_NEW_CALL)
  onMountPanel(): void {
    const { nrSeqUser, nrSeqCategory } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser, nrSeqCategory });
  }

  @OnChange(Aliases.AUTOCOMPLETE_TYPE)
  onChangeCallType(event: ChangeEvent<CallType>): void {
    const { nrSeqCategory } = this.historyService.getCurrentRouteParams();
    const { required, nrSequenceCallType, nrSeqResponsabilityTerm } = event.value;
    if (nrSeqResponsabilityTerm) {
      this.context.set({ nrSeqResponsabilityTerm });
      this.fieldResponsabilityTerm.setVisible(true);
      this.fieldResponsabilityTerm.setValidators([{ name: 'required', options: {} }] as Validator[]);
    } else {
      this.context.set({ nrSeqResponsabilityTerm });
      this.fieldResponsabilityTerm.setVisible(false);
      this.fieldResponsabilityTerm.setValidators([{}] as Validator[]);
    }
    this.fetchGuidance.setParameters({ nrSeqCategory, nrSequenceCallType });
    this.fetchGuidance.forceFetch();
    if (required && required === 'S') {
      this.fieldRequiredAttachment.setVisible(true);
    } else {
      this.fieldRequiredAttachment.setVisible(false);
    }
  }

  @OnAfterFetch(Aliases.FETCH_GUIDANCE)
  onAfterFetchGuidance(event: FetchEvent): void {
    const data = event.data as Call;
    if (isEmptyArrayOrObject(data.guidance)) {
      this.textGuidance.setValue('');
    }
  }

  @OnBeforeSubmit(Aliases.FORM_NEW_CALL)
  OnBeforeSubmit(event: SubmitEvent): void {
    const record = event.record;
    const { nrSeqBeneficiario, nrSeqCategory } = this.historyService.getCurrentRouteParams();
    const callCategory = { nrSeqCategory };
    const body = { ...record, callCategory };
    this.formNewCall.setLoading(true);
    HttpService.post<Call>(Endpoints.POST.NOVO_CHAMADO, { nrSeqBeneficiario }, { body })
      .then((response) => {
        if (!response.body) return;
        const { nrSeqCall } = response.body;
        this.historyService.push(Routes.DETALHES_CHAMADO, { nrSeqCall, nrSeqBeneficiario });
      })
      .catch((error) => {
        this.formNewCall.setLoading(false);
        this.formNewCall.setEditing(true);
        ToastService.open(error);
      });
  }

  @HPMSOnClickTermUse(Aliases.HPMS_TERM_CHECKBOX)
  onClickResponsabilityTerm(): void {
    this.panelResponsabilityTerm.setVisible(true);
  }

  @OnBeforeFetch(Aliases.FETCH_TERM)
  onBeforeFetchTerm(event: FetchEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqResponsabilityTerm } = this.context.getBulkData();
    api.setParameters({ nrSeqTermo: nrSeqResponsabilityTerm });
  }

  @OnClose(Aliases.MODAL_RESPONSABILITY_TERM)
  onCloseModalResponsabilityTerm(): void {
    this.panelResponsabilityTerm.setVisible(false);
  }

  @OnCancel(Aliases.FORM_NEW_CALL)
  oncancel(): void {
    this.historyService.push(Routes.CHAMADOS);
  }

}

export default ChamadoNovoController;
